export default function MiniHeader(props){
   return(
    <div className="headerWrap">
    <h2 className="aboutHeader">{props.title}</h2>
    <h3>{props.subheading}</h3>
    <div className="bar"></div>
    <div className="circle"></div>
</div>
   )
}